import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection, SecurityContext } from '@angular/core';
import { provideMarkdown, SANITIZE } from 'ngx-markdown';
import { provideFirebase } from './core/firebase/firebase.providers';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { provideStore } from '@ngxs/store';
import { de } from 'date-fns/locale';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { unauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';
import { appStates } from './store/app.state';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([tokenInterceptor, httpErrorInterceptor, unauthorizedInterceptor])),
    provideStore(
      appStates,
      withNgxsRouterPlugin(),
      ...(!environment.production ? [withNgxsReduxDevtoolsPlugin({ disabled: false })] : []),
    ),
    provideFirebase(),
    provideServiceWorker('ngsw-worker.js', { enabled: environment.production }),
    provideDateFnsAdapter(),
    provideTranslateService({
      fallbackLang: 'de',
      lang: 'de',
    }),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: de },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-outlined' } },
    provideMarkdown({ sanitize: { provide: SANITIZE, useValue: SecurityContext.HTML } }),
    provideCharts(withDefaultRegisterables()),
  ],
};
